import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface Props {
  width: number;
  height: number;
}
const BlankIcon: React.FC<Props> = t0 => {
  const $ = _c(3);
  const {
    width,
    height
  } = t0;
  let t1;
  if ($[0] !== height || $[1] !== width) {
    t1 = <svg style={{
      width,
      height
    }} />;
    $[0] = height;
    $[1] = width;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BlankIcon;